import { ThemeColor } from "@punks/ui-core"

export const setCssVar = (
  varName: string,
  value?: string | number
): React.CSSProperties => {
  return value
    ? {
      [varName]: value,
    }
    : {}
}

export const normalizeSize = (
  size: number | string | undefined
): string | undefined => {
  return typeof size === "number" ? `${size}px` : size
}


export const getColorClass = (color?: ThemeColor) => {
  switch (color) {
    case "primary":
      return "text-primary"
    case "secondary":
      return "text-secondary"
    case "success":
      return "text-success"
    case "info":
      return "text-info"
    case "warning":
      return "text-warning"
    case "error":
      return "text-error"
    case "light":
      return "text-light"
    case "dark":
      return "text-dark"
    case "grey-10":
      return "text-grey-10"
    case "grey-20":
      return "text-grey-20"
    case "grey-30":
      return "text-grey-30"
    case "grey-40":
      return "text-grey-40"
    case "grey-50":
      return "text-grey-50"
    case "grey-60":
      return "text-grey-60"
    case "grey-70":
      return "text-grey-70"
    case "grey-80":
      return "text-grey-80"
    case "grey-90":
      return "text-grey-90"
    case "white":
      return "text-white"
    case "black":
      return "text-black"
    case "paper":
      return "text-paper"
    case "paperNegative":
      return "text-negative"
    default:
      return ""
  }
}

